import React from "react";

export const NotificationPreview = ({ to, subject, body }) => (
  <div className="wk-card overflow-hidden">
    <div className="flex items-center justify-between px-5 py-3 border-b" style={{ borderColor: "#DEDAE2", background: "#FAF9FB" }}>
      <div className="flex items-center gap-2">
        <div className="w-2 h-2 rounded-full" style={{ background: "#7228C8" }} />
        <span className="text-[12px] uppercase tracking-[0.14em] font-medium" style={{ color: "#7228C8" }}>
          Vista previa · notificación simulada
        </span>
      </div>
      <span
        className="text-[10px] font-medium tracking-wide uppercase px-2 py-1 rounded"
        style={{ background: "rgba(30,25,36,0.06)", color: "#1E1924" }}
      >
        En producción esto sale solo
      </span>
    </div>
    <div className="px-5 py-4">
      <div className="grid grid-cols-[80px_1fr] gap-3 text-[13px] mb-3">
        <div style={{ color: "#70667A" }}>Para</div>
        <div style={{ color: "#1E1924" }}>{to}</div>
        <div style={{ color: "#70667A" }}>Asunto</div>
        <div className="font-semibold" style={{ color: "#1E1924" }}>{subject}</div>
      </div>
      <div className="mt-4 pt-4 border-t whitespace-pre-line text-[14px] leading-[1.6] max-w-prose-tight" style={{ borderColor: "#DEDAE2", color: "#1E1924" }}>
        {body}
      </div>
    </div>
  </div>
);
